
<template>
  <!-- Manage Board Modal -->
  <BaseModal
    :no-exit="true"
    no-toolbar
    card-width="500px"
  >
    <template #default>
      <div class="p-5 flex flex-col items-center text-center">
        <BaseText
          type="label"
          size="lg"
          class="text-text-loud"
        >
          Update Your Subscription
        </BaseText>
        <BaseText
          size="sm"
          class="text-text-normal max-w-sm"
        >
          Please review and confirm the changes to your subscription plan below.
        </BaseText>
      </div>
      <div>
        <!-- Save Board -->
        <div class="flex flex-col justify-between px-5 pt-5">
          <div class="w-full border border-border-normal rounded-xl p-3 relative overflow-hidden">
            <!-- Product icon  -->
            <BaseText
              type="label"
              size="sm"
              class="text-text-muted"
            >
              {{ product.tier }} Plan (${{ product.price?.[product.interval] }}/mo, billed {{ product.interval }})
            </BaseText>
            <BaseText
              size="sm"
              class="text-text-normal max-w-xs mt-1"
            >
              {{ product.description }}
            </BaseText>
            <div class="flex items-center gap-1 mt-3">
              <img
                v-for="featuredProds in featuredProducts"
                :key="featuredProds.key"
                class="w-10 h-10 rounded-md"
                :src="featuredProds.imgUrl"
              >
            </div>
          </div>

          <!-- Cta -->
          <div class="flex flex-col w-full items-center gap-3 pt-5">
            <div class="space-y-2.5">
              <button
                class="black-btn-primary rounded-md py-2 px-2.5 text-white w-full flex items-center justify-center"
                :disabled="loading"
                @click="handleSubscriptionUpdate"
              >
                <BaseLoadingSpinnerCircle
                  v-if="loading"
                />
                <BaseText
                  v-else
                  type="label"
                  size="sm"
                >
                  Yes, change to {{ product.tier }}
                </BaseText>
              </button>
              <BaseText
                size="xs"
                class="text-text-normal text-center"
              >
                You will be charged immediately. Unsued time with be credited towards this purchase.
              </BaseText>
            </div>
            <button
              class="hover:bg-background-normal rounded-md w-max py-2 px-2.5"
              @click="$emit('close')"
            >
              <BaseText
                type="label"
                size="sm"
                class="text-text-muted"
              >
                Nevermind, keep my current plan
              </BaseText>
            </button>
          </div>
        </div>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ChangePlanModal',
  props: {
    product: {
      type: Object,
      default: () => {}
    },
    allProducts: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters('AuthModule', ['getUserSubscription', 'getTeam', 'getTeamSubscriptionState']),
    featuredProducts () {
      return this.allProducts.filter((prod) => this.product?.includedProducts.includes(prod.key))
    }
  },
  async mounted () {
  },
  methods: {
    ...mapActions('AuthModule', ['logoutUser']),
    handleSubscriptionUpdate () {
      if (this.loading) return
      const intervalType = this.product.interval
      const lensCart = this.product?.addOns?.lens?.[intervalType]
      const spyderCart = this.product?.addOns?.spyder?.[intervalType]
      const updatePayload = {
        key: this.product.key,
        priceId: this.product.priceId?.[intervalType],
        addOn: {
          ...(lensCart && { lens: lensCart }),
          ...(spyderCart && { spyder: spyderCart })
        }
      }
      this.$emit('updateSubscription', updatePayload)
    }
  }
}
</script>

<style scoped></style>
